<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="onClick"
  >
    <path
      class="fill"
      d="M3.85947 2.7067C3.72083 2.57281 3.53516 2.49872 3.34243 2.50039C3.1497 2.50207 2.96535 2.57937 2.82906 2.71566C2.69278 2.85194 2.61547 3.0363 2.6138 3.22903C2.61212 3.42175 2.68621 3.60743 2.82011 3.74606L7.06501 7.99097L2.81937 12.2359C2.74917 12.3037 2.69317 12.3848 2.65465 12.4745C2.61612 12.5641 2.59585 12.6606 2.595 12.7582C2.59415 12.8558 2.61275 12.9526 2.64971 13.0429C2.68667 13.1333 2.74125 13.2153 2.81026 13.2843C2.87928 13.3534 2.96135 13.4079 3.05168 13.4449C3.14202 13.4819 3.23881 13.5005 3.33641 13.4996C3.43401 13.4988 3.53046 13.4785 3.62014 13.44C3.70982 13.4014 3.79092 13.3454 3.85873 13.2752L8.10437 9.03032L12.3493 13.2752C12.4879 13.4091 12.6736 13.4832 12.8663 13.4815C13.059 13.4799 13.2434 13.4026 13.3797 13.2663C13.516 13.13 13.5933 12.9456 13.5949 12.7529C13.5966 12.5602 13.5225 12.3745 13.3886 12.2359L9.14373 7.99097L13.3886 3.74606C13.5225 3.60743 13.5966 3.42175 13.5949 3.22903C13.5933 3.0363 13.516 2.85194 13.3797 2.71566C13.2434 2.57937 13.059 2.50207 12.8663 2.50039C12.6736 2.49872 12.4879 2.57281 12.3493 2.7067L8.10437 6.95161L3.85947 2.70597V2.7067Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CloseIcon",
  emits: {
    click: (_payload: MouseEvent) => true,
  },
  setup(_, { emit }) {
    const onClick = (payload: MouseEvent) => emit("click", payload);
    return { onClick };
  },
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
